import LanguageValueObj from "./LanguageValueObj";

export default class GenericLangValueList {
  constructor(initialValue=[]) {
    this.languageValueList=[];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    }
  }

  getList() {
    return this.languageValueList;
  }

  addLanguageValue(lang, value) {
    const obj=new LanguageValueObj();
    obj.setValue(lang, value);
    this.languageValueList.push(obj);
  }

  addNewItem(lang) {
    const obj=new LanguageValueObj();
    obj.setValue(lang, "");
    for (let i=0; i<this.languageValueList.length; i++) {
      const val=this.languageValueList[i].getValue(lang);
      if (this.languageValueList[i].containsLang(lang) && val==="") {
        return false;
      }
    }
    this.languageValueList.push(obj);
    return true;
  }

  removeItem(index) {
    if (index>=this.languageValueList.length||index<0) {
      return;
    }
    this.languageValueList.splice(index, 1);
  }

  removeItemOfLang(index, lang) {
    if (index<0) {
      return;
    }
    let langIndex=0;
    let foundMatch=false;
    for (let iterIndex=0; iterIndex<this.languageValueList.length; iterIndex++) {
      const item=this.languageValueList[iterIndex];
      if (item.containsLang(lang)) {
        langIndex+=1;
        foundMatch=true;
      }
      if ((langIndex-1)===index && foundMatch) {
        this.languageValueList.splice(iterIndex, 1);
        return;
      }
      foundMatch=false;
    }
  }

  parseInputJSON(inputJSON) {
    if (!inputJSON || !Array.isArray(inputJSON)) {
      return;
    }

    for (const entryArray of inputJSON) {
      if (Array.isArray(entryArray)) {
        // Handle the nested arrays of language-value objects
        const langValueObj = new LanguageValueObj();
        for (const entry of entryArray) {
          langValueObj.parseJsonObj(entry);
        }
        this.languageValueList.push(langValueObj);
      }
    }
  }

  print() {
    for (let i=0; i<this.languageValueList.length; i++) {
      this.languageValueList[i].print();
    }
  }

  getExpandedFormatValue() {
    const expandedList=[];
    for (let index=0; index<this.languageValueList.length; index++) {
      const item=this.languageValueList[index];
      expandedList.push(item.getExpandedFormatValue());
    }
    const obj2ret=[];
    expandedList.map((arrayItem, arrayIndex)=>{
      for (let index=0; index<arrayItem.length; index++) {
        obj2ret.push(arrayItem[index]);
      }
    });
    return obj2ret;
  }

  toJSON() {
    // Use map to iterate over each LanguageValueObj and call its toJSON method
    return this.languageValueList.map((languageValueObj) => languageValueObj.toJSON());
  }

  isEmpty() {
    let condition=true;
    for (let index=0; index<this.languageValueList.length; index++) {
      const item=this.languageValueList[index];
      condition=condition&&item.isEmpty();
    }
    return condition;
  }
}
